export const roundOff = (value: number, decimalPlaces: number = 2): number => {
    if (isNaN(value)) {
        return 0;
    }
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(value * factor) / factor;
}